import React from 'react';
import CollectionPage from './collectionPage/CollectionPage';

/**
 * The collection page (Docs · Authorization · Variables · Scripts). The shell,
 * sections and draft model live in ./collectionPage and are shared with the
 * folder page (FolderEditor) — owner D3, 28.09.2026.
 */
export default function CollectionEditor(props) {
  return <CollectionPage {...props} kind="collection" />;
}
